import { type FunctionComponent, memo, type PropsWithChildren } from 'react';

import { Tooltip } from '@air/primitive-tooltip';
import { cn } from '@air/utils-tailwind';

import { type IconType } from '~/types/icons';

type InfoPanelSectionProps = {
  Icon: IconType | FunctionComponent;
  title: string;
  className?: string;
};

export const InfoPanelDetailsSection = memo(
  ({ title, Icon, children, className }: PropsWithChildren<InfoPanelSectionProps>) => {
    return (
      <div
        className={cn(
          'flex gap-4 ads:border-subtle border-gray-3 border-b px-2 py-3 [&:last-of-type]:border-none',
          className,
        )}
      >
        <Tooltip label={title} side="left">
          <Icon
            className="mt-0.5 size-4 shrink-0 cursor-pointer ads:text-icon-subtle text-gray-8"
            data-testid="ai-icon"
          />
        </Tooltip>
        <div className="w-full">{children}</div>
      </div>
    );
  },
);

InfoPanelDetailsSection.displayName = 'InfoPanelSection';
